import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { QRCodeSVG } from "qrcode.react";
import { Stage, ChapterTag } from "@/components/Reveal";
import { Traveler } from "@/components/Motifs";
import { BETA_URL } from "@/config/presentation";

const CROSSING_RANGES = {
  invitation: [0.05, 0.13, 0.24, 0.31],
  threshold: [0.32, 0.4, 0.48, 0.55],
};

export default function Crossing() {
  const ref = useRef(null);
  const { scrollYProgress: p } = useScroll({ target: ref, offset: ["start start", "end end"] });
  const ty = useTransform(p, [0.14, 0.5], ["16vh", "-3vh"]);
  const tOp = useTransform(p, [0.42, 0.56], [1, 0]);
  const tScale = useTransform(p, [0.14, 0.5], [1, 0.62]);
  const qrOp = useTransform(p, [0.55, 0.68], [0, 1]);
  const qrY = useTransform(p, [0.55, 0.68], [44, 0]);
  const welcomeOp = useTransform(p, [0.86, 0.95], [0, 1]);
  const doorScale = useTransform(p, [0, 0.28], [2.4, 1]);

  return (
    <section id="scene-crossing" ref={ref} className="th-scene" style={{ height: "220vh" }} data-testid="scene-crossing">
      <div className="th-sticky">
        <ChapterTag index="08" name="Cross the Threshold" />
        <div className="absolute left-1/2 top-[26%] -translate-x-1/2 flex flex-col items-center">
          <motion.div style={{ scale: doorScale, originX: 0.5, originY: 1 }}>
            <div className="th-door-open" data-testid="open-doorway">
              <div className="th-door-open-light" />
            </div>
          </motion.div>
          <motion.div style={{ y: ty, opacity: tOp, scale: tScale }} data-testid="crossing-traveler">
            <Traveler className="h-12 md:h-14 -mt-2" />
          </motion.div>
        </div>
        <Stage progress={p} range={CROSSING_RANGES.invitation} className="th-stage-top">
          <h3 className="th-question th-halo">Your first conversation is waiting.</h3>
        </Stage>
        <Stage progress={p} range={CROSSING_RANGES.threshold} className="th-stage-top">
          <h3 className="th-display th-halo">Cross the threshold.</h3>
        </Stage>
        <motion.a
          href={BETA_URL}
          target="_blank"
          rel="noreferrer"
          className="th-qr"
          style={{ opacity: qrOp, y: qrY }}
          data-testid="beta-qr-link"
          data-qr-destination={BETA_URL}
          aria-label="Open the Threshold conversation app"
        >
          <span className="th-qr-eyebrow">THRESHOLD · BETA</span>
          <span className="th-qr-code-frame" data-testid="beta-qr-code">
            <QRCodeSVG
              value={BETA_URL}
              size={240}
              level="M"
              marginSize={4}
              fgColor="#111111"
              bgColor="#FFFFFF"
              aria-hidden="true"
            />
          </span>
          <span className="th-qr-title">Join the beta.</span>
          <span className="th-qr-sub">
            Try one conversation.
            <br />
            Tell us what stayed with you.
          </span>
        </motion.a>
        <motion.p className="th-welcome" style={{ opacity: welcomeOp }} data-testid="welcome-line">
          WELCOME TO THRESHOLD
        </motion.p>
      </div>
    </section>
  );
}
